import { Navigate, Outlet, Route } from "react-router-dom";

import { AnimatedBackground } from "components/AnimatedBackground";
import {
  ChooseYourAIAdvisorContainer,
  ChooseYourAIAdvisorContainer_PATH,
} from "modules/personalisation/containers/ChooseYourAIAdvisorContainer";
import {
  DidYouKnowContainer,
  DidYouKnowContainer_PATH,
} from "modules/personalisation/containers/DidYouKnowContainer";
import {
  HeritageContainer,
  HeritageContainer_PATH,
} from "modules/personalisation/containers/HeritageContainer";
import {
  ImproveConcernsContainer,
  ImproveConcernsContainer_PATH,
} from "modules/personalisation/containers/ImproveConcernsContainer";
import {
  JourneyDetailsContainer,
  JourneyDetailsContainer_PATH,
} from "modules/personalisation/containers/JourneyDetailsContainer";
import {
  MeetYourAIAdvisorContainer,
  MeetYourAIAdvisorContainer_PATH,
} from "modules/personalisation/containers/MeetYourAIAdvisorContainer";
import {
  PersonalisationAdvisorBenefitsContainer,
  PersonalisationAdvisorBenefitsContainer_PATH,
} from "modules/personalisation/containers/PersonalisationAdvisorBenefitsContainer";
import {
  PersonalisationIntroContainer,
  PersonalisationIntroContainer_PATH,
} from "modules/personalisation/containers/PersonalisationIntroContainer";
import {
  PersonalisationWelcomeContainer,
  PersonalisationWelcomeContainer_PATH,
} from "modules/personalisation/containers/PersonalisationWelcomeContainer";
import {
  PickYourJourneyContainer,
  PickYourJourneyContainer_PATH,
} from "modules/personalisation/containers/PickYourJourneyContainer";
import {
  PreparingScreenContainer,
  PreparingScreenContainer_PATH,
} from "modules/personalisation/containers/PreparingScreenContainer";
import {
  SkinBalanceContainer,
  SkinBalanceContainer_PATH,
} from "modules/personalisation/containers/SkinBalanceContainer";
import {
  SkinColorFeedbackContainer,
  SkinColorFeedbackContainer_PATH,
} from "modules/personalisation/containers/SkinColorFeedbackContainer";
import {
  SkinSunContainer,
  SkinSunContainer_PATH,
} from "modules/personalisation/containers/SkinSunContainer";
import {
  SkinColorContainer,
  SkinColorContainer_PATH,
} from "modules/personalisation/containers/SkinTypeContainer";
import {
  YouAreNotAloneContainer,
  YouAreNotAloneContainer_PATH,
} from "modules/personalisation/containers/YouAreNotAloneContainer";
import { PersonalisationDataProvider } from "modules/personalisation/context/PersonalisationDataContext";
import { PersonalisationLeaveProvider } from "modules/personalisation/context/PersonalisationLeaveContext";

import { PersonalisationUserGuard } from "../containers/PersonalisationUserGuard";

const PERSONALISE_ROOT = "/personalise" as const;

export function PersonalisationLayout() {
  return (
    <div className="relative mx-auto desk:w-full desk:max-w-2xl sm:w-[390px]">
      <AnimatedBackground>
        <PersonalisationUserGuard>
          <PersonalisationDataProvider>
            <PersonalisationLeaveProvider>
              <Outlet />
            </PersonalisationLeaveProvider>
          </PersonalisationDataProvider>
        </PersonalisationUserGuard>
      </AnimatedBackground>
    </div>
  );
}

export const PersonalisationRoutes = (
  <Route path={PERSONALISE_ROOT} element={<PersonalisationLayout />}>
    <Route index element={<Navigate to={PersonalisationIntroContainer_PATH} replace />} />
    <Route path={PersonalisationIntroContainer_PATH} element={<PersonalisationIntroContainer />} />
    <Route
      path={PersonalisationAdvisorBenefitsContainer_PATH}
      element={<PersonalisationAdvisorBenefitsContainer />}
    />
    <Route path={ChooseYourAIAdvisorContainer_PATH} element={<ChooseYourAIAdvisorContainer />} />
    <Route path={MeetYourAIAdvisorContainer_PATH} element={<MeetYourAIAdvisorContainer />} />
    <Route path={ImproveConcernsContainer_PATH} element={<ImproveConcernsContainer />} />
    <Route path={PickYourJourneyContainer_PATH} element={<PickYourJourneyContainer />} />
    <Route path={JourneyDetailsContainer_PATH} element={<JourneyDetailsContainer />} />
    <Route path={YouAreNotAloneContainer_PATH} element={<YouAreNotAloneContainer />} />
    <Route path={HeritageContainer_PATH} element={<HeritageContainer />} />
    <Route path={SkinColorContainer_PATH} element={<SkinColorContainer />} />
    <Route path={SkinColorFeedbackContainer_PATH} element={<SkinColorFeedbackContainer />} />
    <Route path={SkinSunContainer_PATH} element={<SkinSunContainer />} />
    <Route path={SkinBalanceContainer_PATH} element={<SkinBalanceContainer />} />
    <Route path={DidYouKnowContainer_PATH} element={<DidYouKnowContainer />} />
    <Route path={PreparingScreenContainer_PATH} element={<PreparingScreenContainer />} />
    <Route
      path={PersonalisationWelcomeContainer_PATH}
      element={<PersonalisationWelcomeContainer />}
    />
  </Route>
);
